import { render, staticRenderFns } from "./InventoryDetails.vue?vue&type=template&id=d92d58f4&scoped=true"
import script from "./InventoryDetails.vue?vue&type=script&lang=js"
export * from "./InventoryDetails.vue?vue&type=script&lang=js"
import style0 from "./InventoryDetails.vue?vue&type=style&index=0&id=d92d58f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d92d58f4",
  null
  
)

export default component.exports